import { useEffect, useMemo, useState } from 'react';
import { fetchStaffDashboard } from '../services/staffDashboardService';

function useStaffDashboard() {
  const [dashboardData, setDashboardData] = useState({
    summary: {
      seaweedsStocksKg: 0,
      supplierStocksKg: [],
    },
    records: [],
  });
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  useEffect(() => {
    let isMounted = true;

    async function loadDashboard() {
      setIsLoading(true);
      setLoadError('');

      try {
        const response = await fetchStaffDashboard();

        if (isMounted) {
          setDashboardData({
            summary: {
              seaweedsStocksKg: Number(response?.summary?.seaweedsStocksKg || 0),
              supplierStocksKg: Array.isArray(response?.summary?.supplierStocksKg)
                ? response.summary.supplierStocksKg.map(normalizeSupplierStock)
                : [],
            },
            records: Array.isArray(response?.records) ? response.records : [],
          });
        }
      } catch (error) {
        if (isMounted) {
          setLoadError(error.message);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    }

    loadDashboard();

    return () => {
      isMounted = false;
    };
  }, []);

  const summaryCards = useMemo(
    () => [
      {
        id: 'seaweeds-stocks',
        label: 'Seaweeds Stocks (kg)',
        value: formatKgNumber(dashboardData.summary.seaweedsStocksKg),
        detail: 'Completed supplier deliveries currently recorded in kilograms.',
      },
    ],
    [dashboardData.summary.seaweedsStocksKg]
  );

  return {
    summaryCards,
    supplierStocks: dashboardData.summary.supplierStocksKg,
    deliveryRows: dashboardData.records,
    isLoading,
    loadError,
  };
}

function normalizeSupplierStock(item) {
  return {
    id: item.id || item.supplierName || 'unknown-supplier',
    supplierName: item.supplierName || 'Unknown supplier',
    sacksMarks: Array.isArray(item.sacksMarks)
      ? item.sacksMarks.filter(Boolean)
      : [],
    quantityKg: Number(item.quantityKg || 0),
  };
}

function formatKgNumber(value) {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(value || 0));
}

export default useStaffDashboard;
